import React from "react";
import "./Home.css";
import { SubmissionButton } from "../SumbissionButton";
import { Profile } from "../Profile";

export const PosterCalls = () => {
  const submitButton = {
    title: "Poster/Demo",
    url: "https://edas.info/newPaper.php?c=33045",
  };

  const profilesPoster = [
    {
      title: "Dr",
      firstName: "Nasibeh",
      surname: "Zohrabi",
      university: "Penn State Brandywine, USA",
      bio: "https://www.brandywine.psu.edu/person/nasibeh-zohrabi",
      image: "./images/profiles/Nasibeh.webp",
      linkedin: "https://www.linkedin.com/in/nasibehzohrabi/",
      twitter: null,
      email: "nmz5171@psu.edu",
    },
    {
      title: "Dr",
      firstName: "Francesca",
      surname: "Righetti",
      university: "University of Pisa, Italy",
      bio: "http://for.unipi.it/francesca_righetti/",
      image: "./images/profiles/Francesca.jpg",
      linkedin:
        "https://www.linkedin.com/in/francescarighetti/?originalSubdomain=it",
      email: "francesca.righetti@unipi.it",
    },
  ];

  return (
    <div className="page-layout">
      <div className="text-layout">
        <p style={{ fontWeight: "bold", textAlign: "center" }}>
          *** Accepted Posters, Demos, and WIP papers will be published on IEEE
          Xplore! ***
        </p>
        <SubmissionButton props={submitButton} className="submit-button" />
        <h2>Call for Posters/Demos/WIP</h2>
        <p>
          SMARTCOMP 2025 is the 11th edition of the premier conference on Smart
          Computing. Smart computing is a multidisciplinary domain based on the
          synergistic influence of advances in sensor-based technologies, the
          Internet of Things, cyber-physical systems (CPS), edge computing, big
          data analytics, machine learning, cognitive computing, and artificial
          intelligence. Applications of smart computing can be found in
          different societal domains including, but not limited to,
          transportation, energy, environmental protection, smart and connected
          communities, healthcare, banking, industrial systems, entertainment,
          and social media. Algorithmic and system advancements in cloud
          computing, mobile/pervasive computing, cyber-physical systems, sensor
          networking, and social computing are taking smart computing to a new
          dimension and improving our ways of living.
        </p>
        <p>
          The Posters and Work in Progress (WIP) session will provide a forum to
          discuss novel ideas, preliminary results, present innovative
          applications and tools, and bring about novel research questions,
          approaches, and directions.
        </p>
        <p>
          The Demo session will focus on hands-on demonstrations of preliminary
          works on novel platforms, implementations, and case studies. We
          particularly welcome demos that present innovative designs or
          advancements in CPS, providing attendees with the opportunity to
          experience cutting-edge technology firsthand.
        </p>
        <p>
          We encourage both academia and industry to contribute by sharing
          valuable insights into real-world applications and innovative
          solutions in Smart Computing. Industry submissions are invited to
          reflect practical experiences, field trials, and emerging trends from
          an industrial perspective, demonstrating the impact and applicability
          of Smart Computing technologies.
        </p>
        <p>
          Authors of papers that received favorable reviews but could not be
          accepted to the Main track may be offered the opportunity to publish
          their submitted work in the Posters or Demo tracks.
        </p>
        <h3>Topics</h3>
        <p>Areas of interest include (but are not limited to):</p>
        <ul>
          <li>Future Smart Computing Paradigms</li>
          <li>Models of Smart Environments</li>
          <li>Algorithms for Smart Computing</li>
          <li>AI and Machine Learning in Smart Computing</li>
          <li>Security, Privacy, and Trust Issues in Smart Computing</li>
          <li>Fairness and Socio-technical Issues of Smart Computing</li>
          <li>Cyber-physical System Platforms for Smart Environments</li>
          <li>Middleware Platforms for Smart Environments</li>
          <li>Mobile and Ubiquitous Platforms for Smart Environments</li>
          <li>Cloud, Edge, and Fog Computing Platforms for Smart Systems</li>
          <li>Data Architectures and Analytics for Smart Computing</li>
          <li>Smart Computing for Smart and Connected Communities</li>
          <li>Smart Green Computing</li>
          <li>Social Computing and Smart Systems</li>
          <li>Wearable Computing and IoT for Smart Systems</li>
          <li>Architectures and Software for Smart Computing</li>
          <li>
            Novel Communication Paradigms (e.g., 5G/6G, VLC, DSA) in Smart
            Computing
          </li>
          <li>Quantum Computing in Smart Systems</li>
          <li>Interdisciplinary Approaches to Smart Computing</li>
          <li>
            Applications of Smart Computing include:
            <ul>
              <li>Smart healthcare and digital epidemiology</li>
              <li>Smart agriculture</li>
              <li>Smart infrastructures</li>
              <li>Smart cities</li>
              <li>Smart energy, transportation, water distribution systems</li>
              <li>Smart factories</li>
              <li>Smart workspace</li>
            </ul>
          </li>
        </ul>
        <h3>Submission Guidelines</h3>
        <p>
          Posters, Demos, and WIP papers should be no more than 3 pages in
          length, including figures, tables, and references.
        </p>
        <p>
          All the submissions must be formatted according to the two-column IEEE
          proceedings template. IEEE provides corresponding formatting templates
          at{" "}
          <a href="https://www.ieee.org/conferences/publishing/templates.html">
            IEEE proceedings template
          </a>
          . Make sure to use the conference mode of the template, i.e., LaTeX
          users must use the conference option of the IEEEtran document class.
          While the submission format is the same,{" "}
          <span style={{ fontWeight: "bold" }}>
            the goals for Posters/WIP and Demos are different:
          </span>
        </p>
        <ul>
          <li>
            <span style={{ fontWeight: "bold" }}>Posters/WIP:</span> We welcome
            papers up to 3 pages discussing early or ongoing research.
            Posters/WIP are intended to present ongoing research with a focus on
            novel methodologies, preliminary results, or innovative concepts
            that hold promise for future development, highlighting key ideas, or
            research directions in a concise format, fostering discussion and
            feedback on emerging work/applications.
          </li>
          <li>
            <span style={{ fontWeight: "bold" }}>Demo: </span>We welcome papers
            up to 3 pages focused on the specific component that will be
            demonstrated to the audience and how the attendees will be able to
            interact. They should also provide an overview of the background
            research leading up to the demo.
          </li>
        </ul>
        <p>
          All submitted Posters and Demos will be subject to peer reviews by
          SMARTCOMP Technical Program Committee members and other experts in the
          field.{" "}
          <span style={{ textDecorationLine: "underLine" }}>
            At least one author of each accepted paper must register
          </span>{" "}
          and attend the conference to present the work.
        </p>{" "}
        <p>
          Papers must be submitted electronically as a single PDF file on US
          Letter size paper (not A4), with all fonts embedded (the PDF-A
          standard complies with that), through EDAS. Select Posters/WIP or
          Demos Track at the following link:
        </p>
        <p style={{ fontWeight: "bold", textAlign: "center" }}>
          *** Accepted Posters, Demos, and WIP papers will be published on IEEE
          Xplore! ***
        </p>
        <SubmissionButton props={submitButton} className="submit-button" />
        <h3>Important Dates</h3>
        <p>
          Paper submission:{" "}
          <span style={{ fontWeight: "bold" }}>23 March 2025</span>
        </p>
        <p>
          Acceptance notification:{" "}
          <span style={{ fontWeight: "bold" }}>6 April 2025</span>
        </p>
        <p>
          Camera ready: <span style={{ fontWeight: "bold" }}>10 May 2025</span>
        </p>
        <h3>Posters/Demos/WIP Co-Chairs</h3>
        <div>
          {profilesPoster.map(function (data) {
            return <Profile props={data} />;
          })}
        </div>
      </div>
    </div>
  );
};
